import {Component, Input, OnInit} from '@angular/core';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcRestService} from 'exc-rest-v2';
import {ExgApplicationTabService} from "exc-tab-v2";
import {ExgApplicationEventEmitter} from "../../misc/classes/ExgApplicationEventEmitter";
import {ExcCoreModule} from "exc-core-v2";

@Component({
  selector: 'app-workflow-disposition',
  templateUrl: './workflow-disposition.component.html',
  styles: [
  ]
})
export class WorkflowDispositionComponent implements OnInit {

  private _auID: any;
  @Input()
  set auID(value: any) {
    this._auID = value;
  }

  get auID() {
    return this._auID;
  };

  Events = new ExgApplicationEventEmitter();

  SummaryData: any = {};

  Config: any = {
    SummaryData: {
      selected: [] as any[],
      selectedObjects: [] as any[],
      rowChange: (index: number) => {
        this.Config.SummaryData.selectedObjects = [this.SummaryData.DL[index].oeID];
      }
    }
  };


  constructor(private exgApplicationTabService: ExgApplicationTabService, private excRestService: ExcRestService, public enumSvc: EnumerationService) {
      this.registerEvents();
      this.initialize();
  }

  private registerEvents() {
    if(this._auID) {
      ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
        this.LoadData();
      });
    }
  }

  private initialize() {
  }

  ngOnInit(): void {
    if(this._auID) {
      this.LoadData();
      console.log(this._auID);
    }
  }

  LoadData(): void {
    this.excRestService.get(this.excRestService.computeUrl('TaskR_Disposition', {auID: this._auID})).subscribe((result) => {
      if(result){
        console.log(result);
        this.SummaryData = result.data;
      }
    });
  }

}
